import type { GeneralParameters } from '../../general/parameters/general'
import type { CdnInfoParameters } from '../parameters/cdn-info'

import { Analytix } from '~/shared/analytix'
import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'
import { parameters } from '../parameters/cdn-info'
import { getActivePlayerState } from '../players'

/**
 * Event wrapper for `cdn_info`.
 */
export class CdnInfoEvent extends AnalytixEvent<CdnInfoParameters> {
  name = 'cdn_info'
  group = 'player'
  parameters = parameters
  sender = Analytix.prototype.sendCDNInfoEvent

  gates = [Gate.Uses(seeds.session), Gate.Uses(seeds.player)]

  // coalesce multiple consecutive `cdn_info` events
  override coalescing = false

  // do not expire
  override timeout = Infinity

  constructor() {
    super()
    this.verify()
  }

  validate(): false | [GeneralParameters, CdnInfoParameters] {
    const playerId = this.parameters.get('(playerId)')
    const player = getActivePlayerState(playerId)
    if (player == null) return false

    const valid =
      this.parameters.get('manifest') != null &&
      this.parameters.get('cdnUrl') != null

    if (!valid) {
      this.abort()
      return false
    }

    const parameters: CdnInfoParameters = Object.fromEntries(this.parameters)
    parameters.playbackSessionId = player.playbackSessionId

    return [Object.fromEntries(this.general), parameters]
  }
}
